const Async = (action=function(){},data={}) => new Promise((resolve,reject)=>{
	action(resolve,data);
});

export default Async;